import React from "react";
import { useNavigate } from "react-router-dom";
import error from '../Assets/error.png'

const PageNotFound = () => {
    // To Navigate on any other page
    const navigate = useNavigate();

    return (
        <>
            <div className="flex items-center justify-center h-screen dark:bg-black dark:text-white">
                <div className="text-center flex flex-col md:flex-row items-center">
                    <div className="md:w-1/2">
                        <img
                            src={error}
                            alt="Page Not Found"
                            className="w-full h-auto"
                        />
                    </div>
                    <div className="md:w-1/2 mt-8 md:mt-0 md:ml-8">
                        <p className="text-2xl">
                            <span className="text-red-500">Opps!</span> Page not found.
                        </p>
                        <p className="text-lg mt-2">
                            The page you’re looking for doesn’t exist.
                        </p>
                        <button
                            onClick={() => navigate("/")}
                            className="mt-4 px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
                        >
                            Go Home
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default PageNotFound;